import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { InfoStatusEnum } from 'src/app/share-modul/enums/infoStatus.enum';


@Component({
  selector: 'app-soc-addon-input-withoutform',
  templateUrl: './soc-addon-input-withoutform.component.html',
  styleUrls: ['./soc-addon-input-withoutform.component.scss']
})
export class SocAddonInputWithoutformComponent implements OnInit {

  @Input() label: string | null;
  @Input() label_second: string | null;
  @Input() alertLabel: string | null;
  @Input() addOn: string | null | undefined = "-";
  @Input() status: InfoStatusEnum | undefined = InfoStatusEnum.Info;
  @Input() input: any = "";
  @Input() placeholder: string = "";
  @Input() disabled: boolean = false;
  @Input() formControlName: string | null = null;
  @Input() form: any = null;
  @Output() inputChange = new EventEmitter<any>();

  public infoStatusEnum = InfoStatusEnum;

  constructor() { }

  ngOnInit(): void {
  }

}
